import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-24 px-6 md:px-12 bg-background-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 rounded-full text-xs font-semibold uppercase tracking-wider mb-4">
            Browse All Categories
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950">
            Explore 14 Product Categories
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            Each category links directly to verified product pages on kaspreadsheet.com — click any card to start sourcing instantly
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.slug}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group relative h-48 md:h-56 rounded-xl overflow-hidden cursor-pointer"
            >
              <img
                src={cat.image}
                alt={`OOPBuy Spreadsheet ${cat.name} category`}
                title={`${cat.name} on OOPBuy Spreadsheet`}
                className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                loading="lazy"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/65 via-black/15 to-transparent"></div>
              <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                <h3 className="font-heading text-sm md:text-base font-bold text-white leading-tight">
                  {cat.name}
                </h3>
                <p className="mt-0.5 text-xs text-white/70 line-clamp-2 hidden sm:block">
                  {cat.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}